import {Component} from '@angular/core';
import {MxCustomizer, MxFormCustomizerEvent, MxNotificationService, OnBoFormReady} from 'mx-core';
import {FormGroup} from '@angular/forms';
import {PrlTranslateService} from '../../../../../shared/services/prl-translate.service';
import {Router} from '@angular/router';

@Component({
    selector: 'prl-edit-contact',
    standalone: false,
    templateUrl: './prl-edit-contact.component.html',
    styleUrl: './prl-edit-contact.component.scss',
})
export class PrlEditContactComponent implements MxCustomizer<MxFormCustomizerEvent>, OnBoFormReady {
    private form: FormGroup;
    private readonly parentLink = '/account';
    private readonly parentPanelId = 'contacts';

    constructor(protected readonly translateService: PrlTranslateService,
                private readonly router: Router,
                private readonly notificationService: MxNotificationService
    ) {
    }

    boOnFormReady(form: FormGroup): void {
        this.form = form;
        if (this.form.contains('contactTypeId') && this.form.controls.contactTypeId.value === 1) {
            this.form.controls.contactTypeId.disable();
        }
    }

    onCustomize(event: MxFormCustomizerEvent): void {
        event
            .customizeBoFormConfig({title: this.translateService.getTranslatedLabel('label.modify.account.edit.contact')})
            .customizeProps({
                addPrefixToTitle: false,
                showNavigation: true,
                customNavigation: {
                    onCancel: () => {
                        this.router.navigate([this.parentLink], {fragment: this.parentPanelId});
                    },
                    onBack: () => {
                        this.router.navigate([this.parentLink], {fragment: this.parentPanelId});
                    },
                    onSubmitRedirect: () => {
                        this.checkPrimaryContactAndShowMessage();
                        this.router.navigate([this.parentLink], {fragment: this.parentPanelId});
                    }
                }
            })
            .customizeFormMode('edit')
            .addCustomizer(this);
    }

    checkPrimaryContactAndShowMessage = () => {
        if (this.form.controls.contactTypeId.value === 1) {
            this.notificationService.showSuccess(this.translateService.getTranslatedLabel('label.modify.account.contact.change.message'));
        }
    };
}
